import { IAppSettings } from "../../models";

const defaultState = {} as IAppSettings;

export const SET_SETTINGS = "SET_SETTINGS";

export const settingsReducer = (
  state = defaultState,
  action: any
): IAppSettings => {
  const { type, data } = action;
  if (type === SET_SETTINGS) return data;
  return state;
};
